<style lang="less" scoped>
    .card-content{
        padding: 10px;
        margin-right: 10px;
        margin-bottom: 0px;
        border: 1px solid #dddee1;
        border-bottom: 0px;
        border-left: 0px;
        border-right: 0px;
        text-align: left;
    }
    .linestyle{
      font-size:12px;
      font-family:SourceHanSansSC-Regular,SourceHanSansSC;
      font-weight:400;
      color:rgb(1, 5, 19);
    }
        .card-content{
        padding: 10px;
        margin-right: 10px;
        margin-bottom: 0px;
        border: 1px solid #dddee1;
        border-bottom: 0px;
        text-align: left;
    }
</style>
<template>
  <div class="wrap" style="width: 400px,height: 200px">
      <Row class="line">
          <i-col span = "18">
              <h4 v-if="this.transport_details.length == 0">(暂无物流信息)</h4>
          </i-col>
          <i-col span = "18">
              <h4 v-if="this.msg">{{this.msg}}</h4>
          </i-col>
      </Row>
      <div class="card-content" v-for="(transport_detail,index) in this.transport_details" :key="index">
            <Row class="line">
                <i-col span = "18">
                    <span class="linestyle">更新时间:</span>
                    <div style="width:120px;">    {{transport_detail.time || '  -'}}</div>
                </i-col>
                <i-col span = "18">
                    <span class="linestyle">物流信息:</span>
                    <div style="width: 600px;
                                white-space:normal;
                                word-break:break-all;
                                word-wrap:break-word">    {{transport_detail.status  || '  -'}}</div>
                </i-col>
            </Row>
      </div>
  </div>
</template>
<script>

export default {
        props: {
            model_id: {
                type: Number,
            },
            type: {
              type: String
            },
            tip: {
              type: Boolean,
              default: true
            }
        },
        data(){
            return {
              util: Util,
              transport_detail_path: Util.api.transport_detail,
              transport_details: [],
              msg:''
            }
        },
        computed: {

        },
        created(){
          this.getTransportDetail();
        },
        mounted(){

        },
        methods: {
            getTransportDetail(){
              if(!this.loading){
                this.loading = true;
                Util.ajax.get(this.transport_detail_path, {params: {
                    transport_detail_id: this.model_id
                  }}).then((response) => {
                  return response.data;
                }).then((res) => {
                  if(res.code === 1){
                    this.transport_details = res.data
                    console.log(res.data)
                  }else{
                    this.msg = res.msg
                  }
                }).catch((e) => {
                  this.loading = false;
                  this.empty_tip = '获取数据失败, 请刷新页面重试';
                  console.log(e);
                });
              }
            }
        }
    }
</script>
